export default {
  DECREMENT_LOADER: 'DECREMENT_LOADER',
  INCREMENT_LOADER: 'INCREMENT_LOADER',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_VIEW_BREADCRUMBS: 'SET_VIEW_BREADCRUMBS',
  SET_SIGNED_IN: 'SET_SIGNED_IN',
  RESET_VIEW_BREADCRUMBS: 'RESET_VIEW_BREADCRUMBS',
};



// WEBPACK FOOTER //
// ./store/mutation-types.js